module.exports = __webpack_public_path__ + "img/MarkerSVG.e215ddc3.svg";